import { __assign } from "tslib";
/* eslint-disable import/no-unused-modules,prettier/prettier */
import React, { forwardRef } from 'react';
import { SvgIcon } from '../SvgIcon';
export var CheckmarkFilled = forwardRef(function (props, ref) { return (React.createElement(SvgIcon, __assign({ ref: ref }, props, { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { d: "M7.26838 11.6566L4 8.38864L5.41798 6.97084L7.17788 8.73052L10.4915 5L12 6.33736L7.26838 11.6566Z", fill: "currentColor" }))); });
CheckmarkFilled.displayName = 'CheckmarkFilled';
//# sourceMappingURL=CheckmarkFilled.js.map